import React from 'react';
import { AlertTriangleIcon, XCircleIcon, DollarSignIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 md:py-20 bg-cream" data-id="element-124">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        {/* Story Lead */}
        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-sm border border-gray-100 mb-10 md:mb-16" data-id="element-126">
          <p className="font-heading text-xl md:text-3xl text-navy italic mb-4 leading-relaxed" data-id="element-127">
            "Llegas al concesionario. Eliges el auto que tu familia necesita.
            Pero cuando el vendedor regresa, su cara lo dice todo..."
          </p>
          <p className="font-body text-base md:text-lg text-gray-700 mb-3" data-id="element-128">
            <strong className="text-red-accent" data-id="element-129">
              'Lo siento, tu score es demasiado bajo'.
            </strong>
          </p>
          <p className="font-body text-base md:text-lg text-gray-700" data-id="element-130">
            Esa sensación de vacío no es por el auto... es por la impotencia de
            trabajar 50 horas a la semana y seguir siendo 'insuficiente' para el
            sistema. Es hora de exigir tus derechos.
          </p>
        </div>

        <div className="text-center mb-8 md:mb-12" data-id="element-131">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-navy mb-4" data-id="element-132">
            El Sistema Está Diseñado Para Que Falles
          </h2>
          <p className="font-body text-base md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-133">
            Las agencias te cobran $99 al mes para enviar cartas genéricas que
            los burós tiran a la basura. Mientras tanto, tú sigues pagando
            intereses abusivos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-134">
          <div className="bg-white p-5 rounded-xl shadow-sm border-t-4 border-red-accent" data-id="element-135">
            <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center mb-3" data-id="element-136">
              <AlertTriangleIcon className="w-5 h-5 text-red-accent" data-id="element-137" />
            </div>
            <h3 className="font-heading text-lg font-bold text-navy mb-2" data-id="element-138">
              Intereses Abusivos
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-139">
              Pagas hasta un 24% de interés en tu auto o tarjetas, regalando
              miles de dólares al año.
            </p>
          </div>

          <div className="bg-white p-5 rounded-xl shadow-sm border-t-4 border-red-accent" data-id="element-140">
            <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center mb-3" data-id="element-141">
              <XCircleIcon className="w-5 h-5 text-red-accent" data-id="element-142" />
            </div>
            <h3 className="font-heading text-lg font-bold text-navy mb-2" data-id="element-143">
              Oportunidades Perdidas
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-144">
              Te niegan apartamentos, préstamos de negocio y hasta empleos por
              un número en una pantalla.
            </p>
          </div>

          <div className="bg-white p-5 rounded-xl shadow-sm border-t-4 border-red-accent" data-id="element-145">
            <div className="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center mb-3" data-id="element-146">
              <DollarSignIcon className="w-5 h-5 text-red-accent" data-id="element-147" />
            </div>
            <h3 className="font-heading text-lg font-bold text-navy mb-2" data-id="element-148">
              Dinero Tirado
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-149">
              Las agencias te cobran mensualidades eternas sin garantizarte
              resultados reales.
            </p>
          </div>
        </div>
      </div>
    </section>;
}